import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export const INVITE_TILE_AVATAR_SIZE = 26;
export const INVITE_TILE_COIN_SIZE = 10;
/** A faint primary hairline; the design's rgba(167,139,250,.25) has no theme token. */
const INVITE_ROW_BORDER = 'rgba(167, 139, 250, 0.25)';

export const getInviteTileStyles = (theme: Theme) =>
  StyleSheet.create({
    tile: {
      minHeight: 40,
      backgroundColor: theme.background.boardCard,
      borderRadius: theme.borderRadius.lg,
      borderWidth: 1,
      borderColor: INVITE_ROW_BORDER,
      paddingVertical: 5,
      paddingLeft: 10,
      paddingRight: 5,
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
    },
    /** The tappable left part (avatar + copy + stake); the Accept button sits beside it. */
    openArea: {
      flex: 1,
      minWidth: 0,
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
    },
    openAreaPressed: {
      opacity: 0.75,
    },
    openAreaHover: {
      opacity: 0.9,
    },
    avatar: {
      backgroundColor: theme.background.boardInset,
    },
    text: {
      flexShrink: 1,
      minWidth: 0,
      fontSize: 12,
      color: theme.white,
    },
    name: {
      fontWeight: '700',
    },
    muted: {
      color: theme.gray[500],
    },
    stakeRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 2,
    },
    coin: {
      width: INVITE_TILE_COIN_SIZE,
      height: INVITE_TILE_COIN_SIZE,
    },
    stake: {
      fontSize: 12,
      fontWeight: '800',
      color: theme.accent,
      fontVariant: ['tabular-nums'],
    },
    acceptButton: {
      height: 30,
      paddingHorizontal: 12,
      borderRadius: theme.borderRadius.sm,
      backgroundColor: theme.primary,
      justifyContent: 'center',
      alignItems: 'center',
    },
    acceptButtonPressed: {
      opacity: 0.85,
      transform: [{ scale: 0.97 }],
    },
    acceptButtonHover: {
      opacity: 0.92,
    },
    acceptButtonBusy: {
      opacity: 0.7,
    },
    acceptText: {
      fontSize: 12,
      fontWeight: '800',
      color: theme.onPrimary,
    },
  });

export type InviteTileStyles = ReturnType<typeof getInviteTileStyles>;
